var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33317 13.6667C1.87484 13.6667 1.48248 13.5035 1.15609 13.1771C0.829698 12.8507 0.666504 12.4583 0.666504 12V2C0.666504 1.54167 0.829698 1.14931 1.15609 0.822919C1.48248 0.49653 1.87484 0.333336 2.33317 0.333336H15.6665C16.1248 0.333336 16.5172 0.49653 16.8436 0.822919C17.17 1.14931 17.3332 1.54167 17.3332 2V12C17.3332 12.4583 17.17 12.8507 16.8436 13.1771C16.5172 13.5035 16.1248 13.6667 15.6665 13.6667H2.33317ZM8.99984 7.83334L2.33317 3.66667V12H15.6665V3.66667L8.99984 7.83334ZM8.99984 6.16667L15.6665 2H2.33317L8.99984 6.16667ZM2.33317 3.66667V2V12V3.66667Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.de941609871821daa6343c865840f5f1.svg";
export { ForwardRef as ReactComponent };